export const deepCopy = (item) => JSON.parse(JSON.stringify(item));

export const turnArr = (subject) =>
  Array.isArray(subject) ? subject : [subject];

export const pickOne = (subject, index) =>
  Array.isArray(subject) ? subject[index] : subject;

export function isOne(obj1, obj2) {
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  for (const k in obj1) {
    if (
      typeof obj1[k] === "object" &&
      typeof obj2[k] === "object" &&
      isOne(obj1[k], obj2[k])
    ) {
      continue;
    } else if (obj1[k] !== obj2[k]) {
      return false;
    }
  }
  return true;
}

export function addOrInit(obj, key, value) {
  turnArr(key).forEach((k) => {
    obj[k] = (obj[k] || 0) + value;
  });
}

export const btnState = (isActive) =>
  isActive ? "glow-on-hover" : "unavailable";

export function extractData(object, projection) {
  const result = {};
  for (const field of projection.split(" ")) {
    result[field] = object[field];
  }
  return result;
}

export const bareLv = (lv) => +lv.split("/")[0];

export const splitLv = (subject) => subject.level.split("/").map((lv) => +lv);

export const ascsFromLv = (lv) => {
  const maxLv = +lv.slice(-2);
  return maxLv === 20 ? 0 : maxLv / 10 - 3;
};

const find = (key) => (arr, value) => arr.find((item) => item[key] === value);
const findIndex = (key) => (arr, value) =>
  arr.findIndex((item) => item[key] === value);

export const findById = find("ID");
export const findByIndex = find("index");
export const findByCode = find("code");
export const findByName = find("name");

export const indexById = findIndex("ID");
export const indexByIndex = findIndex("index");
export const indexByCode = findIndex("code");
export const indexByName = findIndex("name");

export const roundMaker = (x) => (n) => {
  const pow = Math.pow(10, x);
  return Math.round(n * pow) / pow;
};

export const round1 = roundMaker(1);
export const round2 = roundMaker(2);
export const round3 = roundMaker(3);

export const applyPct = (n, pct) => Math.round((n * pct) / 100);

export const toMult = (n) => 1 + n / 100;

export const initArtStatFilter = () => ({
  main: "All",
  subs: Array(4).fill("All")
});

export function getTotalXtraTlLv(char, tlData, partyData) {
  let result = 0;
  const { type, getXtraLv } = tlData;
  if (getXtraLv) result += getXtraLv(char);
  if (partyData) {
    const childe = partyData.some((tm) => tm && tm.name === "Tartaglia");
    if (type === "Normal Attack" && (char.name === "Tartaglia" || childe)) {
      result++;
    }
  }
  return result;
}

export const getFinalTlLv = (char, tlData, partyData) => {
  return char[tlData.type] + getTotalXtraTlLv(char, tlData, partyData);
};

export const downloadToDevice = (data) => {
  // type: "application/json"
  const textBlob = new Blob([data], { type: "text/plain" });
  const newLink = document.createElement("a");
  newLink.download = "GDC_Data";
  if (window.webkitURL != null) {
    newLink.href = window.webkitURL.createObjectURL(textBlob);
  } else {
    newLink.href = window.URL.createObjectURL(textBlob);
    newLink.style.display = "none";
    document.body.appendChild(newLink);
  }
  newLink.click();
};
